import { useAppDispatch } from 'src/hooks';
import {
  addCommentForCommentDrawerChildItem,
  addCommentForCommentDrawerParentItem,
  deleteCommentForCommentDrawerChildItem,
  deleteCommentForCommentDrawerParentItem,
  updateCommentForCommentDrawerChildItem,
  updateCommentForCommentDrawerParentItem
} from '../../store/planner-slice';
import { IProductComment } from '../../types/ppg-sku-drawer.model';
import useProductComment from '../../hooks/product-comment-hook';

export default function useCommentDrawer() {
  const appDispatch = useAppDispatch();
  const { handleAddComment, handleDeleteComment, handleUpdateComment } =
    useProductComment();

  const handleAddCommentForParentItem = (
    comment: string,
    productIndex: number,
    key: string
  ) =>
    handleAddComment({ comment_text: comment, productMapping: { [key]: productIndex } }).then((response) => {
      appDispatch(
        addCommentForCommentDrawerParentItem({
          comment: response.payload as IProductComment,
          productIndex,
          key
        })
      );
    });

  const handleDeleteCommentForParentItem = (
    commentId: number,
    productIndex: number,
    key: string
  ) =>
    handleDeleteComment(commentId).then(() => {
      appDispatch(
        deleteCommentForCommentDrawerParentItem({
          commentId,
          productIndex,
          key
        })
      );
    });

  const handleUpdateCommentForParentItem = (
    commentId: number,
    updatedComment: string,
    productIndex: number,
    key: string
  ) =>
    handleUpdateComment(commentId, updatedComment).then((response) => {
      appDispatch(
        updateCommentForCommentDrawerParentItem({
          comment: response.payload as IProductComment,
          productIndex,
          key
        })
      );
    });

  const handleAddCommentForChildItem = (
    comment: string,
    childId: number,
    key: string,
    parentId: number
  ) =>
    handleAddComment({ comment_text: comment, productMapping: { [key]: childId } }).then((response) => {
      appDispatch(
        addCommentForCommentDrawerChildItem({
          comment: response.payload as IProductComment,
          childId,
          parentId
        })
      );
    });

  const handleDeleteCommentForChildItem = (
    commentId: number,
    childId: number,
    parentId: number
  ) =>
    handleDeleteComment(commentId).then(() => {
      appDispatch(
        deleteCommentForCommentDrawerChildItem({
          commentId,
          childId,
          parentId
        })
      );
    });

  const handleUpdateCommentForChildItem = (
    commentId: number,
    updatedComment: string,
    childId: number,
    parentId: number
  ) =>
    handleUpdateComment(commentId, updatedComment).then((response) => {
      appDispatch(
        updateCommentForCommentDrawerChildItem({
          comment: response.payload as IProductComment,
          childId,
          parentId
        })
      );
    });

  return {
    handleAddCommentForParentItem,
    handleAddCommentForChildItem,
    handleUpdateCommentForParentItem,
    handleUpdateCommentForChildItem,
    handleDeleteCommentForParentItem,
    handleDeleteCommentForChildItem
  };
}
